import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "default-content" }
const _hoisted_3 = { class: "danger" }
const _hoisted_4 = { class: "collapse-content" }
const _hoisted_5 = { class: "collapse-content" }
const _hoisted_6 = { class: "edit-form" }
const _hoisted_7 = { class: "collapse-content" }
const _hoisted_8 = { class: "collapse-content" }
const _hoisted_9 = { class: "password-form" }

export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header")
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")
  const _component_UserFilled = _resolveComponent("UserFilled")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")
  const _component_Lock = _resolveComponent("Lock")
  const _component_el_collapse = _resolveComponent("el-collapse")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["windowWidth", "windowHeight"]),
    _createVNode(_component_Navigation, {
      activeMenu: _ctx.NavigationIndex.USER,
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["activeMenu", "windowWidth", "windowHeight"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createElementVNode("div", { class: "danger" }, [
                  _createElementVNode("h4", null, "Zugang verweigert."),
                  _createElementVNode("p", null, "Sie besitzen nicht die erforderliche Berechtigung für diesen Bereich.")
                ], -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, !_ctx.hasPermission['USER_SELECT'] && !_ctx.loading]
        ]),
        (_ctx.hasPermission['USER_SELECT'])
          ? (_openBlock(), _createBlock(_component_Breadcrumbs, {
              key: 0,
              breadcrumbs: [['Benutzer', '/user'], [_ctx.userName]]
            }, null, 8, ["breadcrumbs"]))
          : _createCommentVNode("", true),
        (_ctx.hasPermission['USER_SELECT'])
          ? (_openBlock(), _createBlock(_component_el_container, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_main, { class: "rounded-content" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", _hoisted_3, _cache[9] || (_cache[9] = [
                      _createElementVNode("h4", null, "Achtung:", -1),
                      _createElementVNode("p", null, "Es wurde noch kein Passwort vergeben. Ohne ein Passwort ist die Anmeldung mit diesem Benutzer unmöglich.", -1)
                    ]), 512), [
                      [_vShow, !_ctx.oldPassword && !_ctx.loading]
                    ]),
                    _createVNode(_component_el_collapse, {
                      modelValue: _ctx.activeName,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.activeName) = $event)),
                      accordion: "",
                      ref: "coll"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_collapse_item, { name: "1" }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createVNode(_component_el_icon, { size: 32 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_UserFilled)
                                ]),
                                _: 1
                              })
                            ]),
                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "title-label" }, "Stammdaten", -1))
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("div", _hoisted_6, [
                                _createVNode(_component_el_form, {
                                  ref: "editUserForm",
                                  rules: _ctx.rules,
                                  "label-position": "top",
                                  model: _ctx.userModel,
                                  "label-width": "120px"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, {
                                      label: "Benutzername",
                                      prop: "username"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.userModel.username,
                                          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.userModel.username) = $event)),
                                          onInput: _ctx.onInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "E-Mail",
                                      prop: "email"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.userModel.email,
                                          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.userModel.email) = $event)),
                                          onInput: _ctx.onInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Vorname",
                                      prop: "firstname"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.userModel.firstname,
                                          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.userModel.firstname) = $event)),
                                          onInput: _ctx.onInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Nachname",
                                      prop: "lastname"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.userModel.lastname,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.userModel.lastname) = $event)),
                                          onInput: _ctx.onInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Rolle",
                                      prop: "roleid"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.userModel.roleid,
                                          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.userModel.roleid) = $event)),
                                          placeholder: "[keine]"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_option, {
                                              key: "0",
                                              label: "[keine]",
                                              value: 0
                                            }),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roleModelList, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.roleid,
                                                label: item.description,
                                                value: item.roleid
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          disabled: !_ctx.formUserValid,
                                          onClick: _ctx.onUserSaveClick
                                        }, {
                                          default: _withCtx(() => _cache[11] || (_cache[11] = [
                                            _createTextVNode(" Speichern ")
                                          ])),
                                          _: 1
                                        }, 8, ["disabled", "onClick"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["rules", "model"])
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_collapse_item, { name: "2" }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_el_icon, { size: 32 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Lock)
                                ]),
                                _: 1
                              })
                            ]),
                            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "title-label" }, "Passwort", -1))
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_el_form, {
                                  ref: "editPasswordForm",
                                  rules: _ctx.rules,
                                  "status-icon": "",
                                  "label-position": "top",
                                  model: _ctx.passwordForm,
                                  "label-width": "120px"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, {
                                      label: "Passwort",
                                      prop: "newPassword"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.passwordForm.newPassword,
                                          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.passwordForm.newPassword) = $event)),
                                          type: "password",
                                          autocomplete: "off",
                                          onInput: _ctx.onPasswordInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      label: "Passwort wiederholen",
                                      prop: "repeatPassword"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.passwordForm.repeatPassword,
                                          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.passwordForm.repeatPassword) = $event)),
                                          type: "password",
                                          autocomplete: "off",
                                          onInput: _ctx.onPasswordInput
                                        }, null, 8, ["modelValue", "onInput"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          disabled: !_ctx.formPasswordValid,
                                          onClick: _ctx.onPasswordSaveClick,
                                          loading: _ctx.loadingPassword
                                        }, {
                                          default: _withCtx(() => _cache[13] || (_cache[13] = [
                                            _createTextVNode(" Speichern ")
                                          ])),
                                          _: 1
                                        }, 8, ["disabled", "onClick", "loading"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["rules", "model"])
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}